import ForecastedFuel from "@hydrologiq/shared/monitoring/figures/ForecastedFuel"
import { EnergyUnit } from "@hydrologiq/common/types/energy/consumption"
import { AssetHeadlineFigure } from "@hydrologiq/gql-experience/graphql"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

interface NextRefuelFigureProps {
  data?: AssetHeadlineFigure
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function NextRefuelFigure({ data, loading, error, isPlaceholder, compact = isCompactFigure("summary") }: NextRefuelFigureProps) {
  const value = Math.floor(data?.value ?? 0)
  let minutes = 0

  if (!data?.unit) {
    minutes = value
  } else {
    if (data?.unit === "days") {
      minutes = value * 24 * 60
    } else {
      minutes = value * 60
    }
  }

  const currentLevel = data?.metadata?.usable ?? null

  return (
    <ForecastedFuel
      days={typeof minutes === "number" ? minutes / (24 * 60) : null}
      heading={data?.label}
      unit={currentLevel ? EnergyUnit.kg : undefined}
      currentLevel={currentLevel}
      loading={loading}
      error={error}
      isPlaceholder={isPlaceholder || data?.value === null}
      compact={compact}
    />
  )
}

export default NextRefuelFigure
